module.exports = __webpack_public_path__ + "img/15_001.6049d226.webp";